// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import PipRequiredItem from '@deere/cps-it.warranty-model-factory/lib/pip-required-item';
import {buildNumber} from '../../../shared/services/build-number';

const PartDetails = props =>
    <li className='part-item'>
        <FormattedMessage
            id='PART_ITEM_DETAILS'
            values={{
                description: props.item.description,
                partNumber: props.item.key,
                quantity: buildNumber(props.item.quantity)
            }}
        />
    </li>;

PartDetails.displayName = 'PartDetails';
PartDetails.propTypes = {
    item: PropTypes.instanceOf(PipRequiredItem).isRequired
};

export default PartDetails;



// WEBPACK FOOTER //
// ./src/pip/pip-details/components/part-details.js